/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="row">
          <div className="col-sm-6 mb-16-res">
            <p className="mb-1">&copy; Copyright WS. All Rights Reserved</p>
          </div>
          <div className="col-sm-6 social text-md-end">
            <a className="mr-12" href="https://waleed2194.wordpress.com/" target="_blank" rel="noreferrer">
              <span className="bi bi-wordpress"></span>
            </a>
            <a className="mr-12" href="https://www.instagram.com/waleedshahab" target="_blank" rel="noreferrer">
              <span className="bi bi-instagram"></span>
            </a>
            <a className="mr-12" href="https://www.linkedin.com/in/waleed-shahab-159458151" target="_blank" rel="noreferrer">
              <span className="bi bi-linkedin"></span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
